import { ModifiedIndicator } from '@/components/ModifiedIndicator';
import {
    Button,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverHeader,
    PopoverTrigger,
    Radio,
    RadioGroup,
} from '@chakra-ui/react';
import { mdiChevronDown } from '@mdi/js';
import Icon from '@mdi/react';

/**
 * Renders a button that opens a popover to filter a list of places by status (all, planning, visited).
 *
 * @see `useFilterQueryParam`
 */
export function PlaceStatusFilterControl({
    value,
    isModified,
    onChange,
    onReset,
}: {
    value: string;
    isModified: boolean;
    onChange: (value: string) => void;
    onReset: () => void;
}) {
    return (
        <Popover>
            <PopoverTrigger>
                <Button
                    size='sm'
                    backgroundColor='transparent'
                    position='relative'
                    color='gray.600'
                    px={2}
                    borderColor='gray.300'
                    variant='outline'
                    className='shadow-sm'
                >
                    {isModified && <ModifiedIndicator />}
                    <Icon path={mdiChevronDown} className='size-4' />
                    <span className='ml-2'>Filter</span>
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverHeader fontWeight='semibold'>Filter by status</PopoverHeader>
                <PopoverBody>
                    <RadioGroup defaultValue={value} onChange={onChange} display='flex' flexDirection='column' gap={4}>
                        <div className='flex flex-col items-start gap-2'>
                            <Radio value='all'>All places</Radio>
                            <Radio value='planning'>Planning</Radio>
                            <Radio value='visited'>Visited</Radio>
                            <Radio value='not_visited'>Not visited</Radio>
                        </div>
                    </RadioGroup>
                    <div className='mt-4'>
                        <Button isDisabled={!isModified} size='sm' onClick={onReset}>
                            Reset
                        </Button>
                    </div>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}
